import { Dispatch, SetStateAction } from 'react';
import { Grid, TextField } from '@mui/material';

export default function SpeedLimitEditorField({ label, value, setValue }: { label: string; value: number; setValue: Dispatch<SetStateAction<number>> }) {
    return (
        <Grid item xs={6} sm={4} md={3} lg={2} paddingBottom={1}>
            <TextField label={label} variant='standard' value={value} onChange={e => setValue(parseInt(e.target.value) || 0)} />
        </Grid>
    );
}